export const FEATURED_COMPETITION_FEDERATIONS = [
  "IPF",
  "EPF",
  "AEP-1",
  "AEP-2",
  "AEP-3",
  "WRPF",
];

export const COMPETITION_LEVELS = FEATURED_COMPETITION_FEDERATIONS;

const DEFAULT_FAMILY_ID = "IPF-type";

const FEDERATION_FAMILY_CONFIGS = [
  {
    familyId: "IPF-type",
    menWeightClasses: [
      "-53 kg",
      "-59 kg",
      "-66 kg",
      "-74 kg",
      "-83 kg",
      "-93 kg",
      "-105 kg",
      "-120 kg",
      "+120  kg",
    ],
    womenWeightClasses: [
      "-43 kg",
      "-47 kg",
      "-52 kg",
      "-57 kg",
      "-63 kg",
      "-69 kg",
      "-76 kg",
      "-84 kg",
      "+84 kg",
    ],
    searchableFederations: [
      "IPF",
      "NAPF",
      "PA",
      "CPU",
      "JPA",
      "POSK",
      "IPAM",
      "FIPL",
      "OEVK",
      "FEMEPO",
      "CBLB",
      "ADELEPO",
      "AEP",
      "EPF",
      "AEP-1",
      "AEP-2",
      "AEP-3",
    ],
  },
  {
    familyId: "USAPL-type",
    menWeightClasses: [
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "-100 kg",
      "-110 kg",
      "-125 kg",
      "-140 kg",
      "+140 kg",
    ],
    womenWeightClasses: [
      "-44 kg",
      "-48 kg",
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-65 kg",
      "-70 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "-100 kg",
      "+100 kg",
    ],
    searchableFederations: ["USAPL"],
  },
  {
    familyId: "USPA-IPL-WPU-GPC-type",
    menWeightClasses: [
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "-100 kg",
      "-110 kg",
      "-125 kg",
      "-140 kg",
      "+140 kg",
    ],
    womenWeightClasses: [
      "-44 kg",
      "-48 kg",
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "-100 kg",
      "-110 kg",
      "+110 kg",
    ],
    searchableFederations: [
      "USPA",
      "IPL",
      "WPU",
      "APL",
      "UKPU",
      "NZPU",
      "GPC",
      "API",
      "FEPOA",
      "FPO",
    ],
  },
  {
    familyId: "WRPF-type",
    menWeightClasses: [
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "-100 kg",
      "-110 kg",
      "-125 kg",
      "-140 kg",
      "+140 kg",
    ],
    womenWeightClasses: [
      "-44 kg",
      "-48 kg",
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "+90 kg",
    ],
    searchableFederations: ["WRPF"],
  },
  {
    familyId: "PLU-type",
    menWeightClasses: [
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "-100 kg",
      "-110 kg",
      "-125 kg",
      "-140 kg",
      "+140 kg",
    ],
    womenWeightClasses: [
      "-44 kg",
      "-48 kg",
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "-100 kg",
      "-110 kg",
      "-125 kg",
      "-140 kg",
      "+140 kg",
    ],
    searchableFederations: ["PLU"],
  },
  {
    familyId: "WDFPF-type",
    menWeightClasses: [
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "-100 kg",
      "-110 kg",
      "-125 kg",
      "-145 kg",
      "+145 kg",
    ],
    womenWeightClasses: [
      "-44 kg",
      "-47.5 kg",
      "-50.5 kg",
      "-53 kg",
      "-55.5 kg",
      "-58.5 kg",
      "-63 kg",
      "-70 kg",
      "-80 kg",
      "-90 kg",
      "-110 kg",
      "+110 kg",
    ],
    searchableFederations: ["WDFPF"],
  },
  {
    familyId: "BDFPA-type",
    menWeightClasses: [
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "-100 kg",
      "-110 kg",
      "-125 kg",
      "-145 kg",
      "+145 kg",
    ],
    womenWeightClasses: [
      "-44 kg",
      "-47.5 kg",
      "-50.5 kg",
      "-53 kg",
      "-55.5 kg",
      "-58.5 kg",
      "-63 kg",
      "-70 kg",
      "-80 kg",
      "-90 kg",
      "+90 kg",
    ],
    searchableFederations: ["BDFPA"],
  },
  {
    familyId: "100-RAW-type",
    menWeightClasses: [
      "-30 kg",
      "-35 kg",
      "-40 kg",
      "-44 kg",
      "-48 kg",
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "-100 kg",
      "-110 kg",
      "-125 kg",
      "-140 kg",
      "+140 kg",
    ],
    womenWeightClasses: [
      "-30 kg",
      "-35 kg",
      "-40 kg",
      "-44.5 kg",
      "-48 kg",
      "-52 kg",
      "-56 kg",
      "-60 kg",
      "-67.5 kg",
      "-75 kg",
      "-82.5 kg",
      "-90 kg",
      "+90 kg",
    ],
    searchableFederations: ["100% RAW"],
  },
];

const FEDERATION_ALIASES = {
  EPF: "IPF",
  "AEP-1": "AEP",
  "AEP-2": "AEP",
  "AEP-3": "AEP",
};

const PLUS_WEIGHT_CLASS_REGEX = /^\s*\+/;
const NUMBER_REGEX = /\d+(?:[.,]\d+)?/;

const normalizeLevel = (level) => String(level ?? "").trim().toUpperCase();
const normalizeFederationSearchKey = (level) =>
  normalizeLevel(level).replace(/[^A-Z0-9]+/g, "");

const FAMILY_CONFIG_BY_ID = FEDERATION_FAMILY_CONFIGS.reduce((acc, family) => {
  acc[family.familyId] = family;
  return acc;
}, {});

const FEDERATION_TO_FAMILY_ID = FEDERATION_FAMILY_CONFIGS.reduce((acc, family) => {
  family.searchableFederations.forEach((federation) => {
    acc[normalizeLevel(federation)] = family.familyId;
  });
  return acc;
}, {});

Object.entries(FEDERATION_ALIASES).forEach(([alias, target]) => {
  const familyId = FEDERATION_TO_FAMILY_ID[normalizeLevel(target)];
  if (familyId) {
    FEDERATION_TO_FAMILY_ID[normalizeLevel(alias)] = familyId;
  }
});

export const SEARCHABLE_COMPETITION_FEDERATIONS = Array.from(
  new Set([
    ...FEATURED_COMPETITION_FEDERATIONS,
    ...FEDERATION_FAMILY_CONFIGS.flatMap((family) => family.searchableFederations),
  ])
);

const SEARCHABLE_FEDERATION_BY_NORMALIZED_LEVEL =
  SEARCHABLE_COMPETITION_FEDERATIONS.reduce((acc, federation) => {
    acc[normalizeLevel(federation)] = federation;
    return acc;
  }, {});

const getSearchableFederation = (level) =>
  SEARCHABLE_FEDERATION_BY_NORMALIZED_LEVEL[normalizeLevel(level)] ?? null;

const normalizeSearchableFederationList = (levels = []) => {
  const normalizedFederations = [];
  const seenFederations = new Set();

  levels.forEach((level) => {
    const searchableFederation = getSearchableFederation(level);
    if (!searchableFederation || seenFederations.has(searchableFederation)) {
      return;
    }

    seenFederations.add(searchableFederation);
    normalizedFederations.push(searchableFederation);
  });

  return normalizedFederations;
};

const getFamilyIdForLevel = (level) => {
  const normalizedLevel = normalizeLevel(level);
  if (!normalizedLevel) {
    return DEFAULT_FAMILY_ID;
  }

  return FEDERATION_TO_FAMILY_ID[normalizedLevel] ?? DEFAULT_FAMILY_ID;
};

const getFamilyConfigForLevel = (level) =>
  FAMILY_CONFIG_BY_ID[getFamilyIdForLevel(level)] ??
  FAMILY_CONFIG_BY_ID[DEFAULT_FAMILY_ID];

const compareFederationSuggestions = (left, right, normalizedQuery) => {
  const leftKey = normalizeFederationSearchKey(left);
  const rightKey = normalizeFederationSearchKey(right);

  const score = (value) => {
    if (value === normalizedQuery) return 0;
    if (value.startsWith(normalizedQuery)) return 1;
    if (value.includes(normalizedQuery)) return 2;
    return 3;
  };

  const leftScore = score(leftKey);
  const rightScore = score(rightKey);

  if (leftScore !== rightScore) {
    return leftScore - rightScore;
  }

  if (left.length !== right.length) {
    return left.length - right.length;
  }

  return left.localeCompare(right);
};

export const getCompetitionFederationSuggestions = (query = "", { limit = 20 } = {}) => {
  const candidateFederations = normalizeSearchableFederationList(
    SEARCHABLE_COMPETITION_FEDERATIONS
  );
  const trimmedQuery = String(query ?? "").trim();
  if (!trimmedQuery) {
    return FEATURED_COMPETITION_FEDERATIONS.slice(0, limit);
  }

  const normalizedQuery = normalizeFederationSearchKey(trimmedQuery);
  return candidateFederations.filter((federation) =>
    normalizeFederationSearchKey(federation).includes(normalizedQuery)
  )
    .sort((left, right) =>
      compareFederationSuggestions(left, right, normalizedQuery)
    )
    .slice(0, limit);
};

export const getInitialCompetitionFederationSuggestions = (
  levels = [],
  { limit = 20 } = {}
) => {
  const initialSuggestions = [];
  const seenLevels = new Set();

  levels.forEach((level) => {
    const normalizedLevel = normalizeLevel(level);
    if (!normalizedLevel || seenLevels.has(normalizedLevel)) {
      return;
    }

    const searchableFederation =
      SEARCHABLE_FEDERATION_BY_NORMALIZED_LEVEL[normalizedLevel];
    if (!searchableFederation) {
      return;
    }

    seenLevels.add(normalizedLevel);
    initialSuggestions.push(searchableFederation);
  });

  if (initialSuggestions.length > 0) {
    return initialSuggestions.slice(0, limit);
  }

  return FEATURED_COMPETITION_FEDERATIONS.slice(0, limit);
};

const parseWeightClass = (weightClass) => {
  const normalized = String(weightClass ?? "").trim();
  if (!normalized) {
    return { isPlus: false, value: null };
  }

  const isPlus = PLUS_WEIGHT_CLASS_REGEX.test(normalized);
  const numberMatch = normalized.match(NUMBER_REGEX);
  if (!numberMatch) {
    return { isPlus, value: null };
  }

  return {
    isPlus,
    value: Number.parseFloat(numberMatch[0].replace(",", ".")),
  };
};

export const isWrpfLevel = (level) => getFamilyIdForLevel(level) === "WRPF-type";

export const hasFederationFamilyChanged = (fromLevel, toLevel) =>
  getFamilyIdForLevel(fromLevel) !== getFamilyIdForLevel(toLevel);

export const getWeightClasses = (level, gender) => {
  const familyConfig = getFamilyConfigForLevel(level);
  return gender ? familyConfig.womenWeightClasses : familyConfig.menWeightClasses;
};

const mapToTargetWeightClasses = (weightClass, targetWeightClasses) => {
  const currentWeightClass = String(weightClass ?? "").trim();
  if (!currentWeightClass) {
    return "";
  }

  const sourceParsed = parseWeightClass(currentWeightClass);

  if (sourceParsed.isPlus) {
    return (
      targetWeightClasses.find((target) => parseWeightClass(target).isPlus) ??
      currentWeightClass
    );
  }

  if (sourceParsed.value == null || Number.isNaN(sourceParsed.value)) {
    return currentWeightClass;
  }

  let closestWeightClass = currentWeightClass;
  let smallestDistance = Number.POSITIVE_INFINITY;
  let selectedValue = Number.NEGATIVE_INFINITY;

  targetWeightClasses.forEach((targetWeightClass) => {
    const targetParsed = parseWeightClass(targetWeightClass);
    if (targetParsed.isPlus || targetParsed.value == null) {
      return;
    }

    const distance = Math.abs(targetParsed.value - sourceParsed.value);
    const isCloser = distance < smallestDistance;
    const isTieWithHeavier =
      distance === smallestDistance && targetParsed.value > selectedValue;

    if (isCloser || isTieWithHeavier) {
      smallestDistance = distance;
      selectedValue = targetParsed.value;
      closestWeightClass = targetWeightClass;
    }
  });

  return closestWeightClass;
};

export const mapWeightClass = (weightClass, fromLevel, toLevel, gender) => {
  const currentWeightClass = String(weightClass ?? "").trim();
  if (!currentWeightClass) {
    return "";
  }

  if (!hasFederationFamilyChanged(fromLevel, toLevel)) {
    return currentWeightClass;
  }

  const targetWeightClasses = getWeightClasses(toLevel, gender);
  return mapToTargetWeightClasses(currentWeightClass, targetWeightClasses);
};

export const normalizeWeightClassForLevel = (weightClass, level, gender) => {
  const currentWeightClass = String(weightClass ?? "").trim();
  if (!currentWeightClass) {
    return "";
  }

  const targetWeightClasses = getWeightClasses(level, gender);
  if (targetWeightClasses.includes(currentWeightClass)) {
    return currentWeightClass;
  }

  return mapToTargetWeightClasses(currentWeightClass, targetWeightClasses);
};

export const remapSelectedClientsWeightClasses = (
  clients,
  fromLevel,
  toLevel
) => {
  if (!hasFederationFamilyChanged(fromLevel, toLevel)) {
    return 0;
  }

  let remappedClients = 0;

  clients?.forEach((client) => {
    if (!client?.selectedWeightClass) {
      return;
    }

    const mappedWeightClass = mapWeightClass(
      client.selectedWeightClass,
      fromLevel,
      toLevel,
      client.gender
    );

    if (mappedWeightClass !== client.selectedWeightClass) {
      if (typeof client.setProperty === "function") {
        client.setProperty("selectedWeightClass", mappedWeightClass);
      } else {
        client.selectedWeightClass = mappedWeightClass;
      }
      remappedClients += 1;
    }
  });

  return remappedClients;
};
